export const useMarketingScripts = () => {
  // Flag to track when CookieChimp has loaded
  const cookieChimpLoaded = ref(false);

  const loadCookieChimp = () => {
    if (document.getElementById("cookiechimp")) return;
    const script = document.createElement("script");
    script.src = "https://cookiechimp.com/widget/vG6tqGg.js";
    script.id = "cookiechimp";
    script.async = true;
    script.onload = () => {
      // Once CookieChimp loads, set flag to true
      cookieChimpLoaded.value = true;
    };
    document.head.appendChild(script);
  };

  onMounted(() => {
    // Defer the consent widget until the browser is idle (or a hard 2.5s cap)
    // so it doesn't compete with LCP-critical work on the main thread.
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(() => loadCookieChimp(), { timeout: 2500 });
    } else {
      setTimeout(loadCookieChimp, 1500);
    }
  });

  // Load Google scripts only after CookieChimp has loaded
  watch(cookieChimpLoaded, (isLoaded) => {
    if (isLoaded) {
      // Small delay to ensure CookieChimp is fully initialized
      setTimeout(() => {
        // Load Google Analytics
        useScriptGoogleAnalytics({ id: "G-2WTD67JL4T" });
        // Load Google AdSense
        // useScriptGoogleAdsense({ client: "ca-pub-1226910964236070" });
      }, 1000);
    }
  });
};
